<template>
    <div>
        <Form ref="searchForm" :model="searchForm" inline
              @keyup.enter.native="getList()">
            <FormItem prop="daterange" label="时间范围" :label-width="60">
                <DatePicker :value="searchForm.daterange" type="daterange" split-panels placeholder="选择时间范围"
                            style="width: 240px"
                            format="yyyy-MM-dd" @on-change="searchForm.daterange=$event" :clearable="false"></DatePicker>
            </FormItem>
            <FormItem>
                <Button type="primary" @click="getList" size="small">搜索</Button>
            </FormItem>
        </Form>
        <Table :columns="classlog.columns" :data="classlog.data">
            <template slot-scope="{ row, index }" slot="state">
                <div v-if="row.state==1">未开始</div>
                <div v-else-if="row.state==2"><Tag color="success">已结束</Tag></div>
                <div v-else-if="row.state==3"><Tag color="warning">已取消</Tag></div>
                <div v-else>异常</div>
            </template>
            <template slot-scope="{ row, index }" slot="action">
                <Button @click="classLogStudentList(row)" type="info" size="small" style="margin-right: 5px">上课学员</Button>
                <Button type="primary" size="small" @click="cancelClass(row.id)" v-if="row.state==1" style="margin-right: 5px;">取消</Button>
            </template>
        </Table>

        <cancelWin ref="cancelWin" @on-cancel-success="onCancelSuccess" :mode="1"></cancelWin>
        <classStudentList ref="classStudentList" :clazzId="clazzId" @onchange="onClassStudentChange"></classStudentList>
    </div>
</template>

<script>
  import classStudentList from './classStudentList'
  import cancelWin from '../schedule/cancelWin'
  import moment from 'moment';
  moment.locale('zh-cn');

  export default {
    name: 'clazz_classlog',
    props: {
      detailForm: Object,
      clazzId: Number
    },
    components: {
      classStudentList,
      cancelWin
    },
    data() {
      return {
        classlog:{
          columns:[
            {
              title:'日期',
              key:'date',
              align:'center'
            },
            {
              title:'时间',
              key:'time',
              align:'center'
            },
            {
              title:'教师',
              key:'teacherName',
              align:'center'
            },
            {
              title:'状态',
              align:'center',
              slot:'state'
            },
            {
              title:'备注',
              key:'remark',
              align:'left'
            },
            {
              title:'上课人数',
              key:'studentnum',
              align:'center'
            },
            {
              title:'操作',
              slot:'action'
            }
          ],
          data:[]
        },
        showClassLogStudentsModal:false,
        classLogStudentsColumns:[
          {
            title:'姓名',
            key:'name',
            align:'center'
          },
          {
            title:'状态',
            align:'center',
            slot:'state'
          },
        ],
        classLogStudentsData:[],
        searchForm:{
          daterange: [
            moment(new Date()).subtract(15, 'days').format("YYYY-MM-DD"),
            moment(new Date()).add(30, 'days').format("YYYY-MM-DD")
          ],
        },
      }
    },
    methods: {
      getList: function () {
        console.log(this.clazzId);
        this.$api.clazz.getClassRecordList({
          id: this.clazzId,
          start: this.searchForm.daterange[0],
          end: this.searchForm.daterange[1]
        }).then(res => {
          if (res.state == "ok") {
            this.classlog.data = res.data;
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      classLogStudentList:function(row){
        this.$refs.classStudentList.showModal(row.id)
      },
      cancelClass:function(id){
        this.$refs.cancelWin.showCancelWin(id);
      },
      onCancelSuccess(){
        this.getList();
      },
      onClassStudentChange(){
        this.getList();
      }
    },
    filters:{
    },
  }
</script>
